module.exports = __webpack_public_path__ + "static/media/equals.675ece8d.svg";